import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UIContext from "../context/UIContext";
import SocketContext from "../context/SocketContext";
import Modal from "./common/Modal";


function Footer() {
  const navigate = useNavigate();
  const { inGameRoom, activeLeaveRoomHandler, exitToLobby } = useContext(UIContext);
  const socket = useContext(SocketContext);
  const [showModal, setShowModal] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [pendingPath, setPendingPath] = useState(null);
  const [copied, setCopied] = useState(false);
  const shareUrl = window.location.origin;
  const shareText = encodeURIComponent('Play Game for a Laugh with friends!');
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${shareText}`;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handlePageLinkClick = (event, path) => {
    if (inGameRoom && typeof activeLeaveRoomHandler === "function") {
      event.preventDefault();
      setPendingPath(path);
      setShowLeaveConfirm(true);
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  const performLeaveRoomNavigation = React.useCallback(() => {
    try {
      if (typeof activeLeaveRoomHandler === "function") {
        activeLeaveRoomHandler();
      } else if (typeof exitToLobby === "function") {
        exitToLobby();
      }
    } catch (e) {
      if (typeof exitToLobby === "function") {
        exitToLobby();
      }
    }

    if (socket && socket.connected) return;
    if (typeof exitToLobby === "function") {
      exitToLobby();
    }
  }, [activeLeaveRoomHandler, exitToLobby, socket]);

  const confirmLeaveAndNavigate = () => {
    setShowLeaveConfirm(false);
    window.scrollTo({ top: 0, behavior: 'auto' });
    performLeaveRoomNavigation();

    if (pendingPath) {
      navigate(pendingPath);
    }
    setPendingPath(null);
  };

  const cancelLeaveAndNavigate = () => {
    setShowLeaveConfirm(false);
    setPendingPath(null);
  };

  React.useEffect(() => {
    const handler = () => setShowModal(true);
    window.addEventListener('open-share-modal', handler);
    return () => window.removeEventListener('open-share-modal', handler);
  }, []);

  return (
    <footer className="w-full max-w-4xl mx-auto flex items-center justify-between bg-gray-50 dark:bg-gray-900 rounded-xl shadow-2xl main-panel-shadow px-4 py-4 mt-2 relative">
      <div className="flex flex-col gap-2">
        <div className="text-s font-semibold tracking-[0.18em] text-gray-600 dark:text-gray-300">
          GFAL - Game For A Laugh
        </div>
      {/* App name left */}
      <div className="flex items-center gap-4">
        <Link
          to="/About"
          className="text-sm font-medium tracking-tight text-gray-500 dark:text-gray-400 select-none bg-transparent border-none p-0 m-0 hover:underline dark:hover:text-gray-200 hover:text-gray-800 focus:outline-none"
          aria-label="Open About page"
          onClick={(event) => handlePageLinkClick(event, "/About")}
        >
          About
        </Link>
        <Link
          to="/WhatsNew"
          className="text-sm font-medium text-gray-500 transition-colors hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 hover:underline "
          onClick={(event) => handlePageLinkClick(event, "/WhatsNew")}
        >
          What's New?
        </Link>
        <Link
          to="/Games"
          className="text-sm font-medium text-gray-500 transition-colors hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 hover:underline "
          onClick={(event) => handlePageLinkClick(event, "/Games")}
        >
          Featured Games
        </Link>
        <Link
          to="/HighScores"
          className="text-sm font-medium text-gray-500 transition-colors hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 hover:underline "
          onClick={(event) => handlePageLinkClick(event, "/HighScores")}
        >
          High Scores
        </Link>
      </div>
      </div>
      {/* Share button right */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => setShowModal(true)}
          className="px-3 py-1 rounded bg-blue-600 text-white text-sm font-semibold shadow hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 focus:outline-none"
          style={{ alignSelf: 'center' }}
        >
          Share
        </button>
      </div>
      {/* Share Modal */}
      {showModal && (
        <Modal show={showModal} title="Share" onClose={() => setShowModal(false)}>
          
            
            <div className="mb-4 w-full max-w-md mx-auto bg-gray-100 dark:bg-gray-800 p-4 rounded shadow flex flex-col gap-3">
              <a
                href={twitterUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2 rounded bg-gray-100 dark:bg-gray-700 hover:bg-blue-50 dark:hover:bg-blue-900 transition-colors font-medium"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m4 4l11.733 16H20L8.267 4zm0 16l6.768-6.768m2.46-2.46L20 4"/></svg> Share on X (Twitter)
              </a>
              <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2 rounded bg-gray-100 dark:bg-gray-700 hover:bg-blue-50 dark:hover:bg-blue-900 transition-colors font-medium"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 10v4h3v7h4v-7h3l1-4h-4V8a1 1 0 0 1 1-1h3V3h-3a5 5 0 0 0-5 5v2z"/></svg> Share on Facebook
              </a>
              <button
                onClick={handleCopy}
                className="flex items-center gap-2 px-3 py-2 rounded bg-gray-100 dark:bg-gray-700 hover:bg-green-50 dark:hover:bg-green-900 transition-colors font-medium focus:outline-none"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 15l6-6m-4-3l.463-.536a5 5 0 0 1 7.071 7.072L18 13m-5 5l-.397.534a5.07 5.07 0 0 1-7.127 0a4.97 4.97 0 0 1 0-7.071L6 11"/></svg> {copied ? 'Copied!' : 'Copy URL'}
              </button>
            </div>

        </Modal>
      )}

      {showLeaveConfirm && (
        <Modal show={showLeaveConfirm} title="Leave Game" onClose={cancelLeaveAndNavigate}>
          <div className="w-full max-w-md mx-auto p-4 bg-white dark:bg-gray-800 text-center">
            <p className="mb-4 text-lg dark:text-gray-100">
              Are you sure you want to leave the game room?
            </p>
            <div className="flex justify-center mt-4">
              <button
                className="bg-red-500 text-white p-2 rounded mr-2"
                onClick={confirmLeaveAndNavigate}
              >
                Yes, Leave
              </button>
              <button
                className="bg-gray-300 p-2 rounded dark:bg-gray-600 dark:text-gray-100"
                onClick={cancelLeaveAndNavigate}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      )}
    </footer>
  );
}

export default Footer;
